import React, { Component } from "react";

import "./first-last-name-combo.css";

export class FirstLastNameCombo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: "",
      lastName: "",
    };
    this.submitLock = false;
  }

  inputStyle = {
    borderRadius: 4,
    boxSizing: "border-box",
    color: "#0E283FD9",
    fontSize: 16,
    outline: "none",
    WebkitAppearance: "none",
    borderWidth: 1,
    borderStyle: "solid",
  };

  sendStyle = {
    backgroundImage: 'url("/assets/images/send.svg")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "95% 50%",
  };

  submitIfComplete = () => {
    if (this.submitLock) {
      return;
    }
    const { firstName, lastName } = this.state;
    if (!firstName || !lastName) {
      return;
    }
    this.submitLock = true;
    const payload = { firstName, lastName };
    const displayMessage = `${firstName} ${lastName}`.trim();
    const { dispatchMessage, triggerNextStep } = this.props;

    dispatchMessage(payload);
    triggerNextStep({
      value: payload,
      sendUserMessage: true,
      displayMessage,
    });
  };

  render() {
    return (
      <div className="first-last-name-combo">
        <input
          name="first-name"
          style={{ ...this.inputStyle, paddingLeft: 10 }}
          value={this.state.firstName}
          onChange={(e) => this.setState({ firstName: e.target.value })}
          onKeyUpCapture={(event) => {
            if (event.key === "Enter") {
              const lastNameField = document.querySelector(
                "input[name=last-name]",
              );
              if (lastNameField !== null) {
                lastNameField.focus();
              }
            }
          }}
          placeholder="First Name"
        />
        <input
          name="last-name"
          style={{
            ...this.inputStyle,
            paddingLeft: 10,
            paddingRight: 40,
            ...this.sendStyle,
          }}
          value={this.state.lastName}
          onChange={(e) => this.setState({ lastName: e.target.value })}
          placeholder="Last Name"
          onBlur={() => {
            this.submitIfComplete();
          }}
          onKeyUpCapture={(event) => {
            if (event.key === "Enter") {
              this.submitIfComplete();
            }
          }}
        />
      </div>
    );
  }
}
